import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { take } from 'rxjs';
import { NotificationsStateService } from './services/notifications-state.service';
import { ToolbarNotificationsDropdownComponent } from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';

@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    NgIf
  ]
})
export class ToolbarNotificationsComponent implements OnInit {
  @ViewChild('originRef', { static: true, read: ElementRef })
  originRef?: ElementRef;

  dropdownOpen: boolean = false;
  hasNewNotifications = false;

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private notificationsState: NotificationsStateService
  ) {}

  ngOnInit() {
    this.notificationsState.newNotification$.subscribe((status) => {
      this.hasNewNotifications = status;
      this.cd.markForCheck();
    });
  }

  showPopover() {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    // Don't clear notification indicator until we verify all are read
    // this.notificationsState.setNewNotification(false);

    if (!this.originRef) {
      throw new Error('originRef undefined!');
    }

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;

      // Check if all notifications have been read
      this.notificationsState.notifications$.pipe(take(1)).subscribe(notifications => {
        const hasUnread = notifications.some(notification => !notification.leida);
        this.notificationsState.setNewNotification(hasUnread);
      });

      this.cd.markForCheck();
    });
  }
}
